<app-modal-base [title]="dialogTitle" (onSubmitEvent)="startUploadOrTerminate()" [loading]="uploading"
  [isDisabled]="!canBeClosed || files.size === 0 || (!uploadEnded && !form.valid)" [submitText]="submitText"
  [hasCancel]="showCancelButton">
  <ng-container main *ngTemplateOutlet="content"></ng-container>
</app-modal-base>

<ng-template #content>
  <div class="text-center" *ngIf="data.props.length>1">{{data.props.length}} biens sélectionnés</div>
  <div mat-dialog-content>
    <div appDragDrop (fileDropped)="addFiles($event)">
      <div class="mb-3 text-center">
        <button mat-flat-button color="primary" [disabled]="uploading"
          (click)="data.uploadType === FileUploadType.SCAN_DOC ? startScan() : file.click()">
          {{ uploadButtonText }}
        </button>
        <p *ngIf="uploadDescText">{{ uploadDescText }}</p>
        <input hidden type="file" #file (change)="addFiles($event.target.files)"
          [accept]="acceptFileFormats.length > 0 ? acceptFileFormats : null" multiple />
      </div>
      <div class="text-center">
        <div *ngIf="uploadDoc; else categPhoto">
          <mat-form-field class="col-md-5 col-12 m-1">
            <mat-label>Categorie</mat-label>
            <mat-select placeholder="" required (selectionChange)="onCategoryChange()" [(value)]="docCategory">
              <mat-option *ngFor="let categ of availableDocCategories" [value]="categ">
                {{ availableDocCategoryNames[categ] }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="col-md-5 col-12 m-1">
            <mat-label>Type</mat-label>
            <mat-select placeholder="" required [(value)]="docType">
              <mat-option *ngFor="let type of availableDocTypes" [value]="type">
                {{ availableDocTypeNames[type] }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div *ngIf="showLinkedObject">
          <mat-form-field class="col-md-10 col-12 m-1">
            <mat-label>Lier à</mat-label>
            <mat-select placeholder="" [(value)]="linkObjectId">
              <mat-option>Aucun</mat-option>
              <mat-option *ngFor="let linkObject of linkedObjects" [value]="linkObject.uid">
                {{ linkObject.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <ng-template #categPhoto>
          <div class="photo-selection">
            <mat-form-field class="col-md-10 col-12 m-1">
              <mat-label>Categorie</mat-label>
              <mat-select placeholder="" required [(value)]="photoCategory">
                <mat-option *ngFor="let categ of availablePhotoCategories" [value]="categ">
                  {{ availablePhotoCategoryNames[categ] }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </ng-template>
      </div>

      <div>
        <div *ngIf="prepareFilesForUpload" class="loading">
          <div class="mb-2">Préparation des fichiers...</div>
          <div class="d-flex justify-content-center"><mat-spinner [diameter]="20" color="primary"></mat-spinner></div>
        </div>
        <div class="text-center" *ngFor="let fileToUpload of files; let i = index">
          <mat-form-field class="w-75">
            <mat-progress-bar mode="determinate"
              [style]="!uploadCompleted[fileToUpload.file.name] && !uploadErrors[fileToUpload.file.name] && progress && (progress[fileToUpload.file.name].progress | async) > -1 ? '' : 'visibility: hidden'"
              [value]="(progress ? progress[fileToUpload.file.name]?.progress : 0) | async"></mat-progress-bar>
            <!-- <mat-label>Nom {{ this.data.uploadType === FileUploadType.PHOTO ? 'de la photo' : 'du document'
              }}</mat-label> -->
            <input matInput [formControl]="fileToUpload.fileNameControl" placeholder="Nom" />
            <mat-hint align="end">{{ fileToUpload.file.size | fileSize }}</mat-hint>
            <mat-error>
              <span *ngIf="fileToUpload.fileNameControl.hasError('required')">Veuillez saisir un nom de fichier</span>
            </mat-error>
          </mat-form-field>
          <button mat-icon-button *ngIf="!progress" (click)="deleteFile(fileToUpload)" appTooltip="Supprimer le fichier"
            class="align-middle">
            <mat-icon color="primary" aria-label="Supprimer le fichier">delete_forever</mat-icon>
          </button>
          <mat-icon *ngIf="progress && (progress[fileToUpload.file.name].progress | async) === -1" color="primary"
            class="ms-3 align-text-top">pause</mat-icon>
          <span
            *ngIf="!uploadCompleted[fileToUpload.file.name] && !uploadErrors[fileToUpload.file.name] && progress && (progress[fileToUpload.file.name].progress | async)>-1"
            class="ms-3" style="font-size: small">{{
            progress[fileToUpload.file.name].progress | async }}%</span>
          <button mat-icon-button *ngIf="uploadErrors[fileToUpload.file.name]"
            [appTooltip]="uploadErrors[fileToUpload.file.name]" color="warn">
            <mat-icon aria-label="Error">error</mat-icon>
          </button>
          <mat-icon *ngIf="uploadCompleted[fileToUpload.file.name]" class="ms-3 align-middle" aria-label="success"
            color="accent">check</mat-icon>
        </div>
      </div>
      <div *ngIf="errorMessage" class="alert alert-warning" role="alert">
        {{ errorMessage }}
      </div>
    </div>
  </div>
</ng-template>